"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButtonBar = exports.dividerMargins = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/*
  This is base component for *ButtonBars
  Do not use this directly as it cannot provide complete Type checking
  Use variants such as IconButtonBar or create your own if you need
 */
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../../../atoms/Button/Button");
var Divider_1 = require("../../../atoms/Divider/Divider");
var IconButton_1 = require("../../../atoms/IconButton/IconButton");
var BaseButtonBar_static_1 = require("./BaseButtonBar.static");
var BaseButtonBar_style_1 = __importDefault(require("./BaseButtonBar.style"));
exports.dividerMargins = {
    left: 12,
    right: 12,
};
/**
 * BaseButtonBar molecule
 *
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ButtonBars/BaseButtonBar Source}
 */
var BaseButtonBar = function (_a) {
    var entries = _a.entries, className = _a.className, _b = _a.dividerAtStart, dividerAtStart = _b === void 0 ? false : _b, _c = _a.dividerAtEnd, dividerAtEnd = _c === void 0 ? false : _c;
    var classes = (0, BaseButtonBar_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(className, classes.root) }, { children: [dividerAtStart && (0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: __assign(__assign({}, exports.dividerMargins), { left: 0 }), vertical: true }), entries.map(function (entry, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.entryRoot }, { children: [renderBaseComponent(entry), renderDivider(index)] }), index)); }), dividerAtEnd && (0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: __assign(__assign({}, exports.dividerMargins), { right: 0 }), vertical: true })] })));
    function renderBaseComponent(_a) {
        var title = _a.title, icon = _a.icon, tooltip = _a.tooltip, onClick = _a.onClick, isLoading = _a.isLoading, isDisabled = _a.isDisabled, url = _a.url, stopPropagation = _a.stopPropagation;
        var tooltipText = isLoading ? BaseButtonBar_static_1.localText.loading : tooltip;
        if (!title && icon) {
            return ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { icon: icon, onClick: onClick, tooltip: tooltipText, isLoading: isLoading, isDisabled: isDisabled, stopPropagation: stopPropagation, withoutReservedPadding: true }));
        }
        return (!!title && ((0, jsx_runtime_1.jsx)(Button_1.Button, { isLoading: isLoading, isDisabled: isDisabled, title: title, icon: icon, onClick: onClick, url: url, tooltip: isLoading ? BaseButtonBar_static_1.localText.loading : tooltip, variant: 'text', stopPropagation: stopPropagation })));
    }
    function renderDivider(index) {
        return index < entries.length - 1 ? (0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: exports.dividerMargins, vertical: true }) : null;
    }
};
exports.BaseButtonBar = BaseButtonBar;
